/**
 * (自動車貸渡契約書ダイアログ) LINEコピー機能 Script関数ファイル
 */

/* Import Modules */
import $ from "jquery";
import toastr from "toastr";
import { getLineCopy } from "../axios/rentalContract/lineCopyAxios";

/* Copy Script */
// [LINEコピー]ボタン 押下イベント
export const copyLineClipboardByRentalContract = async () => {
  // Run Axios
  const value = await getLineCopy();

  // Check Axios Responce Value.
  if (!value) toastr.error("スケジュール情報が見つかりません");

  // Make Textarea Element.
  let $element = $("<textarea></textarea>");

  // Insert Copy Value
  $element.text(value);

  // Append Element.
  $(this).append($element);

  // Run Copy
  // document.execCommand('copy');
  navigator.clipboard.writeText($element.val()).then(
    // Show Toastr
    (success) => {
      if (value) toastr.success("コピーしました");
    },
    (error) => toastr.error("予期せぬエラーが発生しました")
  );

  // Remove Element.
  $element.remove();
};
